import Section from '../../components/Section';
import { EXPERIENCES } from './data';
import Experience from './Experience';

const SectionExpPage1 = () => (
  <Section title="Expérience Professionnelle" titleSmall="Expérience">
    {EXPERIENCES.slice(0, 2).map((experience) => (
      <Experience key={experience.company} experience={experience} />
    ))}
  </Section>
);

export default SectionExpPage1;
